import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { MaxWidthView } from '@flix/common/elements/layout'
import { media } from '@flix/common/style/media'
import messages from '../messages'

export const Container = styled(MaxWidthView)`
  text-align: center;
  margin: 70px 0 180px;

  ${media.sm`
    margin-top: 130px;
  `};
`

export const FilmListEmpty = ({ EmptyComponent, emptyLabel }) => {
  return (
    <Container>
      {EmptyComponent ? (
        <EmptyComponent />
      ) : emptyLabel ? (
        <FormattedMessage {...emptyLabel} />
      ) : (
        <FormattedMessage {...messages.emptyFilmList} />
      )}
    </Container>
  )
}
